exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".contenido{\r\n  margin-left: 100px;\r\n  margin-right: 100px;\r\n}\r\n\r\n.center{\r\n  text-align: center;\r\n}\r\n\r\nagm-map {\r\n  height: 300px;\r\n}\r\n\r\n.numero_par{\r\n  background-color: aliceblue;\r\n  color:blue;\r\n}\r\n\r\n#cuadrado{\r\n  height: 200px;\r\n  width: 200px;\r\n  background-color: red;\r\n  }\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/xikoo/Desktop/cursoAngular4/src/app/fundamentos/fundamento.component.css
// module id = ../../../../../src/app/fundamentos/fundamento.component.css
// module chunks = main